import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, CardBody, Input, Button, Table, FormGroup, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import queryString from 'query-string';
import moment from "moment";
import { toast } from 'react-toastify';
import { isEmpty } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Pagination from '../../components/Pagination';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import { connect } from 'react-redux';
import Flatpickr from 'react-flatpickr';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import { baseUrl } from '../../constants/environment';
import IconSearch from '../../assets/images/icon-search.png';
import IconEdit from '../../assets/images/icon-edit.png';
import IconActive from '../../assets/images/icon-active.png';
import IconReject from '../../assets/images/icon-reject.png';
// import IconImport from '../../assets/images/icon-import.png';
import IconImport from '../../assets/images/icon-transfer-import.png';
import IconExport from '../../assets/images/icon-transfer-export.png';
import IconRefund from '../../assets/images/icon-refund.png';

import IconCalendarBlack from '../../assets/images/icon/ic_calendar-black.svg';
import PriceUtils from '../../helpers/PriceUtils';

const configPage = {
    titlePage: 'Danh sách phiếu chuyển kho',
    pathPage: '/stocktransfer',
    column: 8,
}

interface Props {
    history: any,
    location: any,
    user: any,
}
const initialParams = {
    page: 1,
    limit: 25,
    filter: {
        page: 1,
        limit: 25,
        // name:"",
        // sex:"",
    }
}

export const StatusList = [
    {
        value: "",
        label: "-Trạng thái-"
    },
    {
        value: 0,
        label: "Mới"
    },
    {
        value: 1,
        label: "Đã duyệt"
    },
    {
        value: 2,
        label: "Xuất kho"
    },
    {
        value: 3,
        label: "Nhập kho"
    },
    {
        value: 4,
        label: "Chuyển hoàn"
    },
    {
        value: 5,
        label: "Nhập hoàn"
    },
    {
        value: -1,
        label: "Hủy"
    },
]


const List: React.FC<Props> = (props: Props) => {
    const [{ page, limit, filter }, setParams] = useState<any>(initialParams);
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState({});
    const [ids, setIds] = useState([]);
    const [branch, setBranch] = useState([]);
    const [supplier, setSupplier] = useState([]);
    const searchPrams = queryString.parse(props.location.search)

    const setPage = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            page: value
        }));
    }

    const setLimit = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            limit: value
        }));
    }

    const setFilter = (value: {}) => {
        setParams((prevState: any) => ({
            ...prevState,
            filter: value
        }));
    }

    useEffect(() => {
        document.title = configPage.titlePage
        loadInit()
    }, []);

    useEffect(() => {
        loadData()
        setFilterParams({
            page:page,
            limit: limit,
            ...filter,
        });
    }, [filter]);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    const getFilterParams = () => {
        const newFilter: any = {}
        if (!isEmpty(searchPrams)) {
            Object.keys(searchPrams).map(function (key) {
                switch (key) {
                    case 'page':
                        setPage(Number(searchPrams[key]))
                        break;
                    case 'limit':
                        setLimit(Number(searchPrams[key]))
                        break;
                    default:
                        newFilter[key] = searchPrams[key]
                        break;
                }
            });
            setFilter(newFilter)
        }
    }

    const setFilterParams = (params: any) => {
        var filterParams = ''
        Object.keys(params).map(function (item, i) {
            if (i === 0) {
                if (params[item]) filterParams = filterParams + '?' + item + '=' + params[item]
            } else {
                if (params[item]) filterParams = filterParams + '&' + item + '=' + params[item]

            }
        });
        props.history.push({
            search: filterParams
        })
    }

    const loadInit = async () => {
        const params = {
            status:1,
            page:1,
            limit: 100,
        }
        const [
            responseCategory,
            responseSuppliery,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/branch`, params),
            APIClient.GET(`${baseUrl}/supplier`, params),
        ]);
        if (responseCategory.response?.data !== undefined) {
            let ListArr:any = [];
            responseCategory.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setBranch(ListArr)
        }
        if (responseSuppliery.response?.data !== undefined) {
            let ListArr:any = [{
                value: "",
                label: "-Nhà cung cấp-",
            }];
            responseSuppliery.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setSupplier(ListArr)
        }
    }

    const loadData = async () => {
        setLoading(true);
        const formData = {
            page: filter?.page,
            limit: filter?.page,
            ...filter,
        }
        if(formData?.name === "") {
            delete formData?.name
        }
        if(formData?.status === "") {
            delete formData?.status
        }
        if(formData?.from && formData?.to) {
            formData.from = moment(formData?.from).startOf('day').valueOf()
            formData.to = moment(formData?.to).endOf('day').valueOf()
        }
        const url = `${baseUrl}/stock/transfer`;
        let response: any = await APIClient.GET(url, formData);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error)
        } else if (response.response?.data !== undefined) {
            setData(response.response?.data)
            setTotalElements(response.response?.total)
        }
    }

    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: configPage.titlePage, active: true },
                ]}
                title={configPage.titlePage}
            />
            <PageBody>
                <DataFilter
                    filter={filter}
                    configPage={configPage}
                    branch={branch}
                    supplier={supplier}
                    setFilter={(filter: any) => setFilter(filter)}
                />
                <DataTableList
                    user={props?.user}
                    data={data} loading={loading}
                    page={page} limit={limit}
                    configPage={configPage}
                    history={props.history}
                    handleActionModal={(data: any) => handleActionModal(data)}
                />
                {
                    data?.length > 0 &&
                    <Pagination
                        link={configPage.pathPage + '/list'}
                        setPage={(page: number) => setFilter({...filter, page:page})}
                        page={filter?.page}
                        limit={filter?.limit}
                        setLimit={(limit: number) => setFilter({...filter, limit:limit})}
                        type={'noresetpage'}
                        totalElements={totalElements}
                    />
                }
                
            </PageBody>
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                <RenderActionModal closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()}/>
            </ModalPopup>
        </React.Fragment>
    );
};

const DataTableList = (props: any) => {
    const { data, filter, loading, limit, page, is_draft, configPage, handleActionModal} = props
    const start = limit * (page - 1)
    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th style={{ minWidth: 120 }}>Mã phiếu</th>
                    <th style={{ minWidth: 120 }}>Chi nhánh chuyển</th>
                    <th style={{ minWidth: 120 }}>Chi nhánh nhận</th>
                    <th style={{ minWidth: 120 }}>SL chuyển</th>
                    <th style={{ minWidth: 120 }}>SL nhận</th>
                    <th style={{ minWidth: 120 }}>Hỏng hủy</th>
                    <th style={{ minWidth: 120 }}>Trạng thái</th>
                    <th style={{ minWidth: 120, width: 170 }} >Thao tác</th>
                </tr>
            </thead>
        )
    }
    const RenderBobyData = () => {
        const router = useHistory()
        if (loading) {
            return <RowLoading column={configPage.column} row={data.length || limit} />
        }
        if (data.length === 0) {
            return <RowEmpty column={configPage.column} title="Chưa có phiếu chuyển kho nào!" />;
        }
        const gotoDetail = (item:any) => {
            router?.push(`/stocktransfer/${item?.id}/view`)
        }

        return (
            <tbody>
                {data && data.map((item: any, index: number) => {
                    let producQuantity = {
                        export: 0, 
                        import: 0,
                        cancel: 0,
                    }
                    const totalProductExport = item?.stock_transfer_products?.reduce((prevQuantity:any, itemQuantity:any)=>{
                        prevQuantity.export += Number(itemQuantity?.quantity_export || 0)
                        prevQuantity.import += Number(itemQuantity?.quantity_import || 0)
                        prevQuantity.cancel += Number(itemQuantity?.quantity_cancel || 0)
                        return prevQuantity
                    },producQuantity)
                    return (
                        <tr key={index}>
                            <td onClick={() => gotoDetail(item)}>{item?.code}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.branch_id_from?.name}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.branch_id_to?.name}</td>
                            <td onClick={() => gotoDetail(item)}>{PriceUtils.format(totalProductExport?.export || 0, '')}</td>
                            <td onClick={() => gotoDetail(item)}>{PriceUtils.format(totalProductExport?.import || 0, '')}</td>
                            <td onClick={() => gotoDetail(item)}>{PriceUtils.format(totalProductExport?.cancel || 0, '')}</td>
                            <td onClick={() => gotoDetail(item)}>
                                {item?.status == 0 && <span className={'text-dark'}>Mới</span>}
                                {item?.status == 1 && <span className={'text-success'}>Đã duyệt</span>}
                                {item?.status == 2 && <span className={'text-primary'}>Đã xuất kho</span>}
                                {item?.status == 3 && <span className={'text-info'}>Đã nhập kho</span>}
                                {item?.status == 4 && <span className={'text-warning'}>Chuyển hoàn</span>}
                                {item?.status == 5 && <span className={'text-warning'}>Nhập hoàn</span>}
                                {item?.status == -1 && <span className={'text-danger'}>Từ chối</span>}
                            </td>
                            <td className='text-right'>
                                <div className="table-action">
                                    {item?.status === 0 && //mới
                                        <>
                                            <div className="button-nutri" onClick={() => router?.push(`/stocktransfer/${item?.id}`)}>
                                                <img width={20} height={20} src={IconEdit} alt="edit" />
                                            </div>
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'delete', data: item})}>
                                                <i className='uil-trash-alt'></i>
                                            </div>
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'active', data: item})}>
                                                <img width={20} height={10} src={IconActive} alt="edit" />    
                                            </div>
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'reject', data: item})}>
                                                <img width={20} height={20} src={IconReject} alt="edit" />    
                                            </div>
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'export', data: item})}>
                                                <img width={20} height={20} src={IconExport} alt="edit" />    
                                            </div>
                                        </>
                                    }
                                    {item?.status === 1 && //đã duyệt
                                        <>
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'export', data: item})}>
                                                <img width={20} height={20} src={IconExport} alt="edit" />    
                                            </div>
                                        </>
                                    }
                                    {item?.status === 2 && //đã xuất kho
                                        <>
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'import', data: item})}>
                                                <img width={20} height={20} src={IconImport} alt="edit" />    
                                            </div>

                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'return', data: item})}>
                                                <img width={20} height={20} src={IconRefund} alt="edit" />    
                                            </div>
                                        </>
                                    }
                                    {item?.status === 4 && //đã chuyển hoàn
                                        <>
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'returnImport', data: item})}>
                                                <img width={20} height={20} src={IconImport} alt="edit" />    
                                            </div>
                                        </>
                                    }
                                </div>
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        )
    }

    return (
        <div>
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
        </div>
    );
};

const DataFilter = (props: any) => {
    const { setFilter, filter, setPage, branch, supplier} = props
    const [name, setName] = useState(filter?.name);
    const timer = useRef<any>(null);

    const handleChangeFilterDate = (date:any) => {
        if(date.length === 2){
            const from = moment(date[0]).startOf("day").format('YYYY-MM-DD')
            const to = moment(date[1]).endOf("day").format('YYYY-MM-DD')
            setFilter({
                ...filter,
                from:from,
                to:to
            })
        }else if(date.length === 0){
            setFilter({
                ...filter,
                from:undefined,
                to:undefined
            })
        }   
    }

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            clearTimeout(timer.current)
            setFilter({
                ...filter,
                page: 1,
                name: e.target.value,
            })
        }
    }

    const handleChange = (e: any) => {
        clearTimeout(timer.current)
        const { name, value } = e?.target
        if(name == 'provinces_code') {
            setFilter({
                ...filter,
                page: 1,
                district_code: '',
                wards_code: '',
                [name]: value
            })
        }
        else if(name == 'district_code') {
            setFilter({
                ...filter,
                page: 1,
                wards_code: '',
                [name]: value
            })
        }
        else {
            setFilter({
                ...filter,
                page: 1,
                [name]: value
            })
        }
    }

    return (
        <Row className="mb-3 filter-custom">
            <Col xl={10}>
                <Row>
                    <Col xl={3}>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend" className='input-group-prepend-input'>
                                <img src={IconSearch} width={18} height={18} alt=""/>
                            </InputGroupAddon>
                            <Input className='mb-2' onKeyDown={handleKeyDown} onChange={(e: any) => setName(e.target.value)} type="text" value={name} placeholder="Tên hoặc mã phiếu chuyển kho" />
                        </InputGroup>
                    </Col>
                    <Col xl={9}>
                        <Row>
                            <Col xl={4}>
                                <InputGroup className='form-control picker-custom'>
                                    <Flatpickr 
                                        value={[new Date(moment(filter?.from,'YYYY-MM-DD').startOf('day').valueOf()), new Date(moment(filter?.to,'YYYY-MM-DD').startOf('day').valueOf())]}
                                        onChange={(date:any) => { handleChangeFilterDate(date) }} 
                                        options={{
                                            mode: "range",
                                            locale: Vietnamese,
                                            dateFormat: "d/m/Y",
                                        }}
                                        className="flatpickr-input active"
                                        placeholder="Ngày tạo"
                                    />
                                    <div className="icon-clear" style={{right:23}} onClick={()=>{setFilter({...filter, from: null, to:null})}}>
                                        <i className="uil-times mr-1"></i>
                                    </div>
                                    <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                            <img src={IconCalendarBlack} alt="icon" />
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Chi nhánh chuyển-"
                                    options={[{
                                        value: "",
                                        label: "-Chi nhánh chuyển-",
                                    },...branch]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'branch_id_from', value: value.value } })
                                    }}
                                    value={branch?.filter((option: any) => filter?.branch_id_from === option.value)}
                                ></Select>
                            </Col>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Chi nhánh nhận-"
                                    options={[{
                                        value: "",
                                        label: "-Chi nhánh nhận-",
                                    },...branch]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'branch_id_to', value: value.value } })
                                    }}
                                    value={branch?.filter((option: any) => filter?.branch_id_to === option.value)}
                                ></Select>
                            </Col>
                            <Col xl={2}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Trạng Thái-"
                                    options={StatusList}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'status', value: value.value } })
                                    }}
                                    value={StatusList?.filter((option: any) => filter?.status === option.value)}
                                ></Select>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xl={2}>
                <div className="text-right">
                    <Link to={`${configPage.pathPage}/add`}><Button color="success" className="ml-2"><i className='uil uil-plus mr-1'></i>Thêm mới</Button></Link>
                </div>
            </Col>
        </Row>
    );
};

export const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const { closeModal, action, loadData } = props
    const router = useHistory()
    //Xóa
    const handleDelete = async() => {
        setLoading(true)
        const url = `${baseUrl}/stock/transfer/${action?.data?.id}`;
        let response: any = await APIClient.DELETE(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xóa phiếu chuyển kho thành công!')
            closeModal()
            loadData()
        }
    }
    //Đã duyệt
    const handleActive = async() => {
        setLoading(true)
        const url = `${baseUrl}/stock/transfer/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: 1
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xác nhận chuyển kho thành công!')
            closeModal()
            loadData()
        }
    }
    //Từ chối
    const handleReject = async() => {
        setLoading(true)
        const url = `${baseUrl}/stock/transfer/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: -1
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Hủy phiếu chuyển kho thành công!')
            closeModal()
            loadData()
        }
    }
    //Xuất kho
    const handleExport = async() => {
        setLoading(true)
        const url = `${baseUrl}/stock/transfer/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: 2
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Nhập kho thành công!')
            closeModal()
            loadData()
        }
    }
    //Nhập kho
    const handleImport = async() => {
        setLoading(true)
        const url = `${baseUrl}/stock/transfer/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: 3
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Nhập kho thành công!')
            closeModal()
            loadData()
        }
    }
    //Chuyển hoàn
    const handleReturn = async() => {
        setLoading(true)
        const url = `${baseUrl}/stock/transfer/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: 4
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Chuyển hoàn thành công!')
            closeModal()
            loadData()
        }
    }
    //Nhập hoàn
    const handleReturnImport = async() => {
        setLoading(true)
        const url = `${baseUrl}/stock/transfer/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: 5
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Chuyển hoàn thành công!')
            closeModal()
            loadData()
        }
    }
    const handleConfirm = async() => {
        action?.onSubmit()
        closeModal()
    }
    return (
        <CardBody className='p-0' style={{width:400}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    {(action?.type === 'delete') && "Xóa phiếu"}
                    {(action?.type === 'active' || action?.type === 'activeConfirm') && "Xác nhận phiếu"}
                    {action?.type === 'reject' && "Từ chối phiếu"}
                    {(action?.type === 'import' || action?.type === 'importConfirm') && "Nhập kho"}
                    {(action?.type === 'export' || action?.type === 'exportConfirm') && "Xuất kho"}
                    {action?.type === 'return' && "Chuyển hoàn"}
                    {action?.type === 'returnImport' && "Nhập hoàn"}
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body pt-2 pb-2">
                <Col md={12}>
                    <FormGroup row className="label-only">
                        {action?.type === 'delete' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn xóa phiếu chuyển kho này</p>
                        }
                        {(action?.type === 'active' || action?.type === 'activeConfirm') &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn đổi trạng thái phiếu sang Đã duyệt</p>
                        }
                        {action?.type === 'reject' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn đổi trạng thái phiếu sang Từ chối</p>
                        }
                        {(action?.type === 'import' || action?.type === 'importConfirm') &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn chuyển trạng thái phiếu chuyển kho sang Đã nhập kho</p>
                        }
                        {(action?.type === 'export' || action?.type === 'exportConfirm') &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn đổi trạng thái phiếu sang Đã xuất kho.</p>
                        }
                        {action?.type === 'return' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn chuyển trạng thái phiếu chuyển kho sang Chuyển hoàn?</p>
                        }
                        {action?.type === 'returnImport' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}> Bạn có chắc chắn muốn chuyển trạng thái phiếu chuyển kho sang Nhập hoàn?</p>
                        }
                    </FormGroup>
                </Col>
            </div>
            <div className="modal-footer">
                <Button
                    onClick={()=>{
                        action?.type === 'active' && handleActive()
                        action?.type === 'activeConfirm' && handleConfirm()
                        action?.type === 'reject' && handleReject()
                        action?.type === 'import' && handleImport()
                        action?.type === 'export' && handleExport()
                        action?.type === 'importConfirm' && handleConfirm()
                        action?.type === 'return' && handleReturn()
                        action?.type === 'returnImport' && handleReturnImport()
                        action?.type === 'delete' && handleDelete()
                        action?.type === 'exportConfirm' && handleConfirm()
                    }}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>
            {loading && <Loader />}
        </CardBody>

    )
}

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(List)